const WALLET_ARRAY_COUPONS_KEY = 'coupon';

// eslint-disable-next-line
export { WALLET_ARRAY_COUPONS_KEY };
